<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
    <path
      fill="currentColor"
      d="M11.7,26.7c-0.5,0-1.1-0.2-1.5-0.6l-8.6-8.6c-0.8-0.8-0.8-2.2,0-3s2.2-0.8,3,0l7.1,7.1L27.3,5.9c0.8-0.8,2.2-0.8,3,0
          s0.8,2.2,0,3L13.2,26.1C12.8,26.5,12.3,26.7,11.7,26.7z"
    />
  </svg>
</template>
